<template>
  <standard-container
    :title="$t('schedule.player-title')"
    overflow="auto"
  >
    <template v-slot:title>
      <transition name="players-autocomplete-slide">
        <v-text-field
          v-if="showSearch"
          v-model="search"
          class="player-search"
          :placeholder="$t('schedule.player-search')"
          clearable
        />
      </transition>
      <v-btn
        icon
        @click="showSearch = !showSearch"
      >
        <v-icon> search </v-icon>
      </v-btn>
    </template>
    <template v-slot:content>
      <v-flex>
        <v-treeview
          v-model="cSelectedPlayer"
          :items="playersItem"
          :selectable="true"
          open-on-click
          :hoverable="true"
          :search="search"
          return-object
          dense
        >
          <template v-slot:append="{ item }">
            <v-icon :key="iconKey">
              {{ item.icon ? "mdi-calendar-clock" : "" }}
            </v-icon>
          </template>
        </v-treeview>
      </v-flex>
    </template>
  </standard-container>
</template>

<script>
// Components
import standardContainer from "../Common/StandardContainer";

export default {
  components: {
    standardContainer,
  },
  props: {
    height: {
      type: String,
      default: "65vh",
    },
    iconSchedule: {
      type: Array,
      default: () => [],
    },
    playersItem: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      iconTimeout: null,
      search: "",
      selectedPlayer: [],
      showSearch: false,
      iconKey: 0,
    };
  },
  computed: {
    heightComponent() {
      return "height: " + this.height;
    },
    cSelectedPlayer: {
      get() {
        return this.selectedPlayer;
      },
      set(val) {
        val.forEach((player) => {
          player.icon = false;
        });

        this.selectedPlayer = val;
        this.$emit("playerSelected", this.selectedPlayer);
      },
    },
  },
  watch: {
    iconSchedule: function (val) {
      this.selectedPlayer.forEach((player) => {
        for (let i = 0; i < val.length; i++) {
          if (player.name == val[i]) {
            player.icon = true;
          } else {
            player.icon = false;
          }

          this.iconKey++;
        }
      });

      clearTimeout(this.iconTimeout);

      // Show 10 secs the calendar icon
      this.iconTimeout = setTimeout(() => {
        this.resetIcon();
      }, 10000);
    },
  },
  methods: {
    resetIcon() {
      this.playersItem.forEach((players) => {
        players.children.forEach((player) => {
          player.icon = false;
        });
      });

      this.iconKey++;
    },
  },
};
</script>

<style>
.player-search {
  position: relative;
  top: 10px;
}
</style>
